export default "__VITE_ASSET__Ocyb2fbU__"